import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import React from "react";
import { SkeletonPage } from './Skeleton';

interface Props {
  children: React.ReactNode;
}



export default function AuthGate({ children }: Props): React.ReactElement {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, (firebaseUser: any) => {
      setUser(firebaseUser);
      setLoading(false);
    });
  }, []);

  if (loading) return <SkeletonPage variant="auth" label="Checking your session" />;

  if (!user) return <Navigate to="/login" replace />;

  return <>{children}</>; // This ensures it's a JSX.Element
}
